module.exports = __webpack_public_path__ + "static/media/test1 (13).ae5f362e.jpg";